var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeOutRejected = function SvgTakeOutRejected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM22.1787 22.1785C21.5278 22.8294 20.4726 22.8294 19.8217 22.1785L16.0002 18.357L12.1787 22.1785C11.5278 22.8294 10.4726 22.8294 9.82169 22.1785C9.17082 21.5277 9.17082 20.4724 9.82169 19.8215L13.6432 16L9.82149 12.1783C9.17061 11.5274 9.17062 10.4721 9.82149 9.82126C10.4724 9.17039 11.5276 9.17039 12.1785 9.82126L16.0002 13.643L19.8217 9.82148C20.4726 9.17061 21.5278 9.17061 22.1787 9.82148C22.8296 10.4724 22.8296 11.5276 22.1787 12.1785L18.3572 16L22.1787 19.8215C22.8296 20.4723 22.8296 21.5276 22.1787 22.1785Z",
    fill: "currentColor"
  })));
};
export default SvgTakeOutRejected;